/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedGovIcon24Solid = forwardRef('BookClosedGovIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5a4 4 0 0 1 4-4h11.75A2.25 2.25 0 0 1 21 3.25v13.5A2.25 2.25 0 0 1 18.75 19H6a1 1 0 1 0 0 2h14a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3V5Zm5 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.25A1.75 1.75 0 0 1 14.25 14h-.69l-1.207 1.206a.5.5 0 0 1-.707 0L10.44 14h-.69A1.75 1.75 0 0 1 8 12.25V7Z" })));
});
